import { CONTACT } from "@/lib/constants";
import { ArrowRight } from "lucide-react";
import { useApplyIntent } from "@/components/ApplyIntent";
import { useRateCheckRouter } from "@/components/RateCheckRouter";
import { useMLO } from "@/lib/mloContext";
import { resolveApplyUrl } from "@/lib/applyTarget";

export default function FinalCTA() {
  const { openIntent } = useApplyIntent();
  const { openRouter } = useRateCheckRouter();
  const mlo = useMLO();
  const intentOpts = { applyUrl: resolveApplyUrl(mlo), mloSlug: mlo?.slug, mloName: mlo?.name, mloPhone: mlo?.phone };
  const firstName = (mlo?.name || "Jason Gray").split(" ")[0];
  const phone = mlo?.phone || CONTACT.phoneDisplay;
  const phoneHref = mlo?.phone ? `tel:${mlo.phone.replace(/[^+0-9]/g, "")}` : CONTACT.phoneHref;
  return (
    <section data-testid="final-cta-section" className="relative section-y overflow-hidden grain-bg noise text-white">
      <div className="container-grc relative text-center">
        <p className="text-xs font-bold tracking-[0.22em] uppercase text-lime">
          Ready when you are
        </p>
        <h2 className="mt-5 font-heading font-medium text-4xl sm:text-6xl leading-[1.05] text-balance max-w-4xl mx-auto">
          Your <span className="italic text-lime">great rate</span> is one click away.
        </h2>
        <p className="mt-6 text-lg text-white/75 max-w-2xl mx-auto">
          Start your NEXA Lending application and {firstName} will personally
          review your scenario within one business day.
        </p>
        <div className="mt-9 flex flex-col sm:flex-row items-center justify-center gap-4">
          <button
            type="button"
            data-testid="final-cta-primary"
            onClick={() => mlo ? openIntent("final-cta-primary", intentOpts) : openRouter("final-cta-primary")}
            className="inline-flex items-center gap-2 bg-lime hover:bg-lime-hover text-navy-deep font-semibold text-base px-9 py-4 rounded-full shadow-cta hover:shadow-cta-hover transition-all hover:-translate-y-0.5"
          >
            Check My Rate <ArrowRight size={18} />
          </button>
          <a
            data-testid="final-cta-secondary"
            href={phoneHref}
            className="text-white/90 hover:text-white font-medium underline decoration-white/30 underline-offset-4 hover:decoration-lime transition-colors"
          >
            Or call {phone}
          </a>
        </div>
      </div>
    </section>
  );
}
